import { Pipe, PipeTransform } from '@angular/core';
import { FormControl } from '@angular/forms';
import { getErrorMessage } from '../../utils/string';

@Pipe({
  name: 'formError',
  standalone: false
})
export class FormErrorPipe implements PipeTransform {
  transform(control: FormControl, ...args: string[]): boolean | string {
    const errorPipe = args[0];
    const isError = control.dirty && control.invalid;
    const errorMessage = isError ? getErrorMessage(control) : '';
    return errorPipe === 'isError' ? isError : errorMessage;
  }
}
